import React, { useContext } from "react";
import { useWindowDimensions } from "./TopHeader";
import { useNavigate } from "react-router";
import { AccountContext } from "../contexts/AccountContext";

function WidgetRecommended({ item }) {
  const { width } = useWindowDimensions();

  const router = useNavigate();
  const [accountState, dispatchAccount] = useContext(AccountContext);
  const bar_title = item.bar_title;
  const barFontSizeValue =
    item.bar_font_size == 0.0 ? 12.0 : item.bar_font_size;
  const bar_font_size =
    width > 650 ? `${barFontSizeValue}px` : `${barFontSizeValue / 1.2}px`;

  return (
    <div
      style={{
        background: `linear-gradient(165deg, ${item?.background_color_secondary}, ${item?.background_color_primary} 20%)`,
      }}
      onClick={() => {
        router(`/${item.type}/${item.type_id}`);
        dispatchAccount({
          type: "setGrid1BannerRecommendedID",
          payload: item.banner_recommended_id,
        })
      }}
      className="cursor-pointer"
    >
      <div className="px-2">
        <div className="flex justify-between w-full">
          <h2
            style={{
              color: item.font_color,
              fontWeight: "900",
              fontFamily: item?.font_type,
            }}
            className="lg:text-lg text-[0.8rem]"
          >
            {item.title}
          </h2>
          <span className="cursor-pointer ml-4 lg:text-lg text-[0.8rem]  mr-1">
            &gt;
          </span>
        </div>

        <p className="mb-1 lg:text-lg text-[0.8rem] h-[40px] ">
          {item.description}
        </p>
      </div>

      <div className="flex gap-2 px-2">
        {item.items?.slice(0, 2).map((product) => {
            const special = product?.special;
            const parts = special.split(" ");
            const price = parts[0];
            const unit = parts[1];

          return (
            <div
              key={product.product_id}
              style={{ position: "relative", display: "inline-block" }}
            >
              <img src={product.thumb} className="lg:w-[220px] lg:h-[300px]" />
              {bar_title !== "" && (
                <span
                  style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    fontSize: bar_font_size,
                    color: item?.bar_font_color,
                    backgroundColor: item?.bar_background_color,
                    padding: "1px 4px",
                    minHeight: "1.2em",
                    lineHeight: "1.2em",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    pointerEvents: "none",
                    transform: "translateY(-90%)",
                    fontFamily: item?.bar_font_type,
                  }}
                >
                  {bar_title}
                </span>
              )}

              {width > 650 ? (
                <>
                  <div className="flex items-center justify-between my-1">
                    {product.special && (
                      <div className="font-extrabold text-black gap-1 flex items-end flex-nowrap whitespace-nowrap">
                        
                        <span style={{ fontSize: "20px" }}>{price}</span>
                        <span style={{ fontSize: "14px" }}>{unit}</span>
                        {/* {fraction && (
                          <span
                            style={{
                              fontSize: "12px",
                            }}
                          >
                            .{fraction}
                          </span>
                        )} */}
                      </div>
                    )}

                    {accountState?.admin && (
                      <span className="bg-dgrey1 bg-opacity-25 p-2 rounded">
                        {product.quantity}
                      </span>
                    )}
                  </div>
                </>
              ) : (
                <div className="flex items-center justify-between my-1">
                 {product.special && (
                      <div className="font-extrabold text-black flex items-end flex-nowrap whitespace-nowrap gap-1">
                        
                        <span style={{ fontSize: "16px" }}>{price}</span>
                        <span style={{ fontSize: "13px" }}>{unit}</span>
                        {/* {fraction && (
                          <span
                            style={{
                              fontSize: "12px",
                            }}
                          >
                            .{fraction}
                          </span>
                        )} */}
                      </div>
                    )}

                  {accountState?.admin && (
                    <span className="bg-dgrey1 bg-opacity-25 p-1 rounded">
                      {product.quantity}
                    </span>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default WidgetRecommended;
